module.exports = __webpack_public_path__ + "assets/img/hill-4.20f10d3d.png";